<template>
  <div class="fine_plays_page">
    <div class="search_group">
      <div class="search_item">
        <div class="search_item_label">組織</div>
        <div class="search_item_select">
          <el-select clearable v-model="branch" placeholder="" @change="fetchFinePlays">
            <el-option v-for="item in branches" :key="item.branch_code" :label="item.branch_name" :value="item.branch_code"/>
          </el-select>
        </div>
      </div>
    </div>
    <div class="fine_plays_group">
        <div v-for="finePlay in finePlays">
          <div class="fine_play_item" @click="handleClickFinePlay(finePlay.id)">
            <div class="fine_play_date_name">
              <span class="date">{{finePlay.created_at | dateFormat}}</span>
              <span class="name">{{finePlay.institution.abbreviated_name_kanji}}</span>
            </div>
            <div class="fine_play_title">
              <span>{{finePlay.presenter_company_code}}</span>
              <span>{{finePlay.employee.name_kanji}}</span>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {mapActions} from 'vuex'
  import FinePlayApi from '../../api/fine-plays'
  import CompanyOrganizationsApi from '../../api/company-organizations'
  import {MR_AUTHORITY_HEAD_OF_BRANCH, MR_AUTHORITY_HEAD_OF_DEPARTMENT, MR_AUTHORITY_SM, MS_COMPANY_CODE} from '../../config'

  export default {
    data () {
      return {
        MR_AUTHORITY_HEAD_OF_BRANCH,
        MR_AUTHORITY_HEAD_OF_DEPARTMENT,
        MR_AUTHORITY_SM,
        companies: [],
        branches: [],
        company: MS_COMPANY_CODE,
        branch: null,
        finePlays: []
      }
    },
    computed: {
      canFetchBranches: function () {
        const authorities = [MR_AUTHORITY_HEAD_OF_BRANCH, MR_AUTHORITY_HEAD_OF_DEPARTMENT, MR_AUTHORITY_SM]
        return authorities.findIndex(n => n === this.$auth.user().authority) === -1
      }
    },
    methods: {
      ...mapActions({
        setNavigatorLinks: 'navigator/setLinks',
        setNavigatorTitle: 'navigator/setTitle'
      }),
      async fetchBranches () {
        this.branch = null
        const res = await CompanyOrganizationsApi.getBranches({company_code: this.company})
        this.branches = _.filter(res.data.data, n => n.branch_code !== '0')
      },
      async fetchFinePlays () {
        const res = await FinePlayApi.get({active: true, company_code: this.company, branch_code: this.branch})
        this.finePlays = res.data.data
      },
      async fetchData () {
        const loading = this.$loading.show()
        try {
          await this.fetchFinePlays()
        } catch (e) {
          console.log(e)
        }
        loading.hide()
      },
      async handleChangeCompany () {
        await this.fetchBranches()
        await this.fetchFinePlays()
      },
      handleClickFinePlay (finePlayId) {
        this.$router.push({name: 'finePlays.show', params: {finePlayId}})
      }
    },
    async mounted () {
      await this.fetchData()
      await this.fetchBranches()
      this.setNavigatorLinks([])
      this.setNavigatorTitle('ファインプレー')
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/fine-plays/index.vue